<template>
	<div>
		<span v-if="!isIconeVisivel">
			{{ fimValidade | formatDataFilter }}
		</span>
		<v-tooltip color="black" top v-if="isIconeVisivel">
			<template #activator="{ on, attrs }">
				<span v-on="on" v-bind="attrs">
					{{ fimValidade | formatDataFilter }}
					<v-icon
						@:mouseover="atualizarTextoVenciemento()"
						v-if="isIconeVisivel"
						:color="isVencida() ? 'red darken-2' : 'yellow darken-3'"
						>access_time</v-icon
					>
				</span>
			</template>
			<span class="d-block text-center">
				{{ inicioValidade | formatDataFilter }} a {{ fimValidade | formatDataFilter }}</span
			>
			<span class="d-block text-center">
				{{ textoVencimento }}
			</span>
		</v-tooltip>
	</div>
</template>

<script>
import { DataUtils } from '@/core/utils'

export default {
	name: 'icone-relogio',
	props: {
		fimValidade: {
			type: String,
			required: true,
		},
		inicioValidade: {
			type: String,
			required: true,
		},
		limiteDiasAVencer: {
			type: Number,
			default: 15,
		},
	},

	data() {
		return {
			textoVencimento: '',
		}
	},

	computed: {
		isIconeVisivel() {
			return (
				DataUtils.isVencido(this.fimValidade) ||
				DataUtils.isProximoAVencer(this.fimValidade, this.limiteDiasAVencer)
			)
		},
	},

	methods: {
		isVencida() {
			return DataUtils.isVencido(this.fimValidade)
		},
		atualizarTextoVenciemento() {
			this.textoVencimento = 'Termina '
			if (this.isVencida()) this.textoVencimento = 'Terminou '
			this.textoVencimento = this.textoVencimento + DataUtils.getTextoVencimento(this.fimValidade)
		},
	},
}
</script>
<style lang="stylus" scoped>
.v-icon
	margin 4px
	font-size 16px
	margin-bottom 6px
</style>
